
export const VALIDATOR_MESSAGES = {
    REQUIRED: 'This field is required',
    MIN_LENGTH: (min: number) => `Minimum ${min} characters required`,
    MAX_LENGTH: (max: number) => `Maximum ${max} characters allowed`,
    MIN: (min: number) => `Minimum ${min} characters required`,
    MAX: (max: number) => `Maximum ${max} characters allowed`,
    INVALID_EMAIL: 'Please enter a valid email address (e.g., example@example.com)',
    EMAIL_NO_WHITESPACE: 'Email must not contain spaces',
    WITHOUTSPECIALCHAR: 'Special characters are not allowed',
    PASSWORD_PATTERN: 'Password must contain uppercase, lowercase, number, and special character',
    PASSWORD_MATCH: 'Passwords do not match',
    AGREE_TERMS: 'You must accept the Terms and Conditions',
    INVALID_MOBILE: 'Please enter a valid international phone number (e.g., +14155552671)',
    INVALID_WEBSITE_URL: 'Please enter a valid website URL (e.g., https://www.example.com)',
    INVALID_POSTAL_CODE: 'Please enter a valid postal code (e.g., 12345 or 12345-6789)',
    INVALID_MOBILE_NUMBER: 'Please enter a valid mobile number (e.g., 1234567890)',
    INVALID_ALPHABET_WITH_SPACE: 'Please enter a valid alphabet with space',
    INVALID_ALPHABET_WITH_SPACE_AND_NUMBER: 'Please enter a valid alphabet with space and number',
    INVALID_ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR: 'Please enter a valid alphabet with space and number and special character',
    INVALID_ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR_AND_HYPHEN: 'Please enter a valid alphabet with space and number and special character and hyphen',
    INVALID_APP_ID: 'Please enter a valid app id (e.g., AAAA1234)',

    PASSWORD: {
        HAS_LOWERCASE: 'Password must contain at least one lowercase letter',
        HAS_UPPERCASE: 'Password must contain at least one uppercase letter',
        HAS_NUMBER: 'Password must contain at least one number',
        HAS_SPECIAL_CHAR: 'Password must contain at least one special character',
        VALID_CHAR_SET: 'Password must contain only valid characters',
        MIN_LENGTH: 'Password must be at least 8 characters long',
    }
};
